// All site copy lives here so it can be updated without touching components.
// Sourced from the company profile document.

export const company = {
  name: "MS Trading & Investment LLC",
  legalNameEn: "Maad and Sakina for Trading & Investment LLC",
  legalNameAr: "معد و سكينة للتجارة و الإستثمار ش م م",
  tagline: "Precision. Quality. Innovation.",
  intro:
    "A premier supplier in Oman of laboratory instruments, glassware, consumables, furniture, and storage solutions — equipping labs across education, healthcare, research, industry, and government.",
};

export const contact = {
  address: "Muscat, Oman",
  phoneDisplay: "+968 9525 3005",
  phoneHref: "tel:+96895253005",
  whatsappHref: "https://wa.me/96895253005",
  email: "info@msllcoman.com",
  emailHref: "mailto:info@msllcoman.com",
  website: "msllcoman.com",
};

export const about = {
  body: [
    "MS Trading & Investment is a premier supplier in Oman, delivering world-class laboratory instruments, glassware, consumables, laboratory furniture, and storage & shelving solutions. We partner with top international manufacturers to equip laboratories across education, healthcare, research, industry, and government sectors with reliable, high-performance products.",
    "Our commitment goes beyond supply. We provide tailored solutions, technical expertise, and ongoing support, ensuring our clients achieve the highest levels of efficiency and precision.",
  ],
  equipment: [
    "Laboratory Ovens",
    "Incubators",
    "Flue Gas Analyzers",
    "Balances",
    "Lab Crushers",
    "Mills",
    "Microscopes",
  ],
};

export const vision =
  "To be Oman's most trusted and innovative provider of laboratory solutions, enabling scientific progress and discovery.";

export const mission = [
  "Deliver superior laboratory products that meet international quality standards.",
  "Provide unmatched technical support and after-sales service.",
  "Foster long-term partnerships built on trust and excellence.",
];

export const solutions = [
  {
    title: "Laboratory Instruments",
    items: [
      "Analytical Instruments",
      "Testing & Measurement Devices",
      "Sample Preparation Equipment",
    ],
  },
  {
    title: "Glassware & Consumables",
    items: [
      "Beakers, Flasks, Pipettes, Test Tubes",
      "Filtration Products",
      "Disposable Laboratory Items",
    ],
  },
  {
    title: "Laboratory Furniture",
    items: ["Modular Workbenches", "Fume Hoods", "Ergonomic Seating"],
  },
  {
    title: "Storage & Shelving",
    items: [
      "Chemical Storage Cabinets",
      "Mobile & Static Shelving",
      "Heavy-Duty Racking Systems",
    ],
  },
];

export const whyChooseUs = [
  {
    title: "Quality Assurance",
    description: "Only premium products from trusted global brands.",
  },
  {
    title: "Technical Expertise",
    description: "Guidance on selection, installation, and usage.",
  },
  {
    title: "Local Reach",
    description: "Fast delivery and responsive after-sales support in Oman.",
  },
  {
    title: "Custom Design",
    description: "Tailored laboratory layouts and storage solutions.",
  },
];

export const clients = ["Oman Sugar Refinery Company (OSRC)"];

export const suppliers = [
  "LAB Commercial",
  "Auxilab",
  "CHEMSTOCK",
  "Al Nawras Medi-Lab Supplies",
  "Chemistry for Life LLC",
  "Laboratory Scientific Supplies",
];

export const galleryImages = [
  { src: "images/image1.jpg", alt: "Laboratory equipment supplied by MS Trading & Investment" },
  { src: "images/image2.jpg", alt: "Laboratory instruments and analytical devices" },
  { src: "images/image3.png", alt: "Laboratory glassware and consumables" },
  { src: "images/image4.jpg", alt: "Laboratory furniture and workbench installation" },
  { src: "images/image5.jpg", alt: "Storage and shelving solutions for laboratories" },
  { src: "images/image6.jpg", alt: "Laboratory setup and fit-out by MS Trading & Investment" },
];

export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Solutions", href: "#solutions" },
  { label: "Why Us", href: "#why-us" },
  { label: "Partners", href: "#partners" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

// EmailJS credentials. The public key is designed to be client-side visible;
// restrict allowed origins in the EmailJS dashboard to prevent abuse.
export const emailjsConfig = {
  serviceId: "service_cjuwyg9",
  templateId: "template_mz3x7kk",
  publicKey: "qTn9pDka5sxw9q0-W",
};
